import { useState, useEffect, useContext } from 'react'
import ContextStates from '../context/ContextStates'


const SearchAutoComplete = ({ innerRef, ...props }) => {
    const [busqueda, setBusqueda] = useState([])
    const [pos, setPos] = useState(-1)

    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const { codigo, setCodigo, searchTerm, setSearchTerm } = useContext(ContextStates)


    useEffect(() => {
        if (codigo === '') {
            setSearchTerm('')
            setBusqueda([])
            setIsDropdownVisible(false)
            setPos(-1)
            setHighlightedIndex(-1)
        }
    }, [codigo])

    // Reset position when search results change
    useEffect(() => {
        setPos(-1)
        setHighlightedIndex(-1)
    }, [searchTerm])

    // Reset position when dropdown becomes visible
    useEffect(() => {
        if (isDropdownVisible && busqueda.length > 0) {
            setPos(-1)
            setHighlightedIndex(-1)
        }
    }, [isDropdownVisible])

    const filter = (item) => {
        let bus = item.target.value
        setSearchTerm(item.target.value)
        if (props.items) {
            if (item.target.value !== '') {
                let rData = []
                props.items.forEach(element => {
                    const palabrasCadena = element.label.toLowerCase().split(/\s+/);
                    const palabras = bus.toLowerCase().split(/\s+/);
                    if (palabras.every(palabraBuscada => {
                        const encontrado = palabrasCadena.some(palabraCadena => {
                            if (palabraCadena.includes(palabraBuscada)) {
                                return true;
                            }
                            return false;
                        });
                        return encontrado;
                    })) {
                        rData.push(element)
                    }
                });
                setBusqueda(rData)
                setIsDropdownVisible(true)
            }
            else {
                setBusqueda([])
                setIsDropdownVisible(false)
            }
        }
    }

    const handleItemSelect = (item) => {
        setSearchTerm(item.label);
        setCodigo(item.codigo)
        setIsDropdownVisible(false);
        setPos(-1)
        setHighlightedIndex(-1)
    };

    const handleKeyDown = (event) => {
        if (busqueda.length === 0) return;

        let posAct = pos;

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setIsDropdownVisible(true);
            if (posAct < busqueda.length - 1) {
                posAct++;
                setPos(posAct)
                setHighlightedIndex(posAct)
            }
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            if (posAct > -1) {
                posAct--;
                setPos(posAct)
                setHighlightedIndex(posAct)
            }
        } else if (event.key === 'Enter') {
            event.preventDefault();
            if (highlightedIndex >= 0 && highlightedIndex < busqueda.length) {
                handleItemSelect(busqueda[highlightedIndex]);
            }
        } else if (event.key === 'Escape') {
            setIsDropdownVisible(false);
            setPos(-1)
            setHighlightedIndex(-1)
        }
    };

    return (
        <div className="w-full relative">
            <label htmlFor="descripcion" className="block text-gray-700 font-bold mb-1 text-sm">Descripción</label>
            <input
                type='text'
                ref={innerRef}
                className="py-2 px-4 w-full rounded-lg border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white font-medium"
                value={searchTerm}
                onChange={filter}
                onKeyDown={handleKeyDown}
                onFocus={() => {
                    if (busqueda.length > 0) {
                        setIsDropdownVisible(true)
                    }
                }}
                placeholder="Buscar producto..."
                autoComplete="off"
            />
            {isDropdownVisible && busqueda.length > 0 && (
                <ul
                    className='absolute mt-1 w-full border-2 border-blue-300 rounded-lg shadow-xl bg-white z-50 max-h-64 overflow-y-auto'
                >
                    {busqueda.map((item, index) => (
                        <li
                            key={index}
                            onClick={() => handleItemSelect(item)}
                            className={`p-3 cursor-pointer transition-all duration-150 border-b border-gray-100 last:border-b-0 ${highlightedIndex === index
                                    ? 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-semibold'
                                    : 'hover:bg-blue-50 text-gray-800'
                                }`}
                        >
                            {item.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default SearchAutoComplete